import { vals } from "@/lib/format";

export const normPlate = (s) => (s || "").toUpperCase().replace(/[^A-Z0-9\u0600-\u06FF]/g, "");
export const OIL_RE = /aceite|oil|زيت|huile|filtro de aceite/i;
export const OIL_KM = 10000;
export const OIL_MONTHS = 6;

export const findVehicle = (customers, plate) => {
  const n = normPlate(plate);
  if (n.length < 3) return null;
  for (const c of vals(customers)) for (const v of c.vehicles || []) { const p = normPlate(v.plate); if ((p && (p === n || (n.length >= 5 && p.startsWith(n)))) || (v.vin && v.vin.toUpperCase() === n)) return { ...v, customer_id: c.id, customer_name: c.name }; }
  return null;
};

export const vehicleSales = (sales, vehicleId) => vals(sales).filter((s) => s.vehicle?.id === vehicleId).sort((a, b) => b.created_at.localeCompare(a.created_at));

export function maintenance(v, sales) {
  const oil = vehicleSales(sales, v.id).find((s) => s.items.some((i) => OIL_RE.test(i.name)));
  if (!oil) return { status: "unknown", lastAt: null, lastKm: null, nextKm: null, nextDate: null };
  const lastKm = Number(oil.vehicle?.km) || null;
  const nextDate = new Date(oil.created_at); nextDate.setMonth(nextDate.getMonth() + OIL_MONTHS);
  const nextKm = lastKm ? lastKm + OIL_KM : null;
  const km = Number(v.km) || 0;
  const due = nextDate < new Date() || (nextKm && km >= nextKm);
  const soon = !due && ((nextKm && km >= nextKm - 1000) || (nextDate - new Date()) < 30 * 864e5);
  return { status: due ? "due" : soon ? "soon" : "ok", lastAt: oil.created_at, lastKm, nextKm, nextDate: nextDate.toISOString().slice(0, 10) };
}

export const warrantyEnd = (saleAt, months) => { if (!months) return null; const d = new Date(saleAt); d.setMonth(d.getMonth() + Number(months)); return d; };
export const warrantyExpired = (saleAt, months) => { const e = warrantyEnd(saleAt, months); return e ? e < new Date() : false; };
